export const CSS_COLORS = Object.freeze({
  PRIMARY: '#5171CB', // プライマリボタン、選択中の状態など
  SECONDARY: '#EEF1F9', // セカンダリボタン、選択中の状態、テーブル背景やカード背景など
  BACKGROUND1: '#121725', // ヘッダーなど
  BACKGROUND2: '#25282E', // ナビゲーション
  BACKGROUND3: '#F6F6F6', // 見出し、非アクティブな領域など
  BACKGROUND4: '#FFFFFF', // 全体背景、ボタンやテキストフィールドの塗り
  SUCCESS: '#7B9F4B', // 成功、安全、完了など
  ERROR: '#C46163', // 失敗やエラーのほか、危険情報や制約条件の提示などの注意喚起
  WARNING: '#B7A54B', // 警告や禁止事項など
  BLUE: '#2F71FF',
  GRAYSCALE1: '#000000',
  GRAYSCALE2: '#616266',
  GRAYSCALE3: '#B2B2B2',
  GRAYSCALE4: '#EAEAEA',
  GRAYSCALE5: '#FAFAFA',
  GRAYSCALE6: '#FFFFFF',
})
